import { memo } from "react";
import isEqual from "react-fast-compare";

const WINDOW_SEAT = (
	<i
		className="-ml-0.5 w-3 h-4 block bg-center bg-contain bg-no-repeat mr-[1px] opacity-50"
		style={{ backgroundImage: "url(/images/AirplaneWindow.svg)" }}
	/>
);
const WAY_SEAT = (
	<i className="-ml-0.5 w-3 h-4 block mr-[2.5px] opacity-50 ic-round md-add_road" />
);
const MIDDLE_SEAT = (
	<i className="ic-outline md-event_seat opacity-60 mr-[1px] scale-105 -ml-0.5" />
);

const SeatIcon = memo(({ type, model }: { type: string; model?: string }) => {
	if (!model) return null;

	if (model === "空客A320") {
		if (["A"].includes(type)) return WINDOW_SEAT;
		if (["C"].includes(type)) return WAY_SEAT;
	} else if (model === "空客A321") {
		if (["F"].includes(type)) return WINDOW_SEAT;
		if (["E"].includes(type)) return MIDDLE_SEAT;
	} else if (model === "空客A350") {
		if (["J"].includes(type)) return WAY_SEAT;
		if (["L"].includes(type)) return WINDOW_SEAT;
	} else if (model === "波音737") {
		if (["J"].includes(type)) return WAY_SEAT;
		if (["L"].includes(type)) return WINDOW_SEAT;
	} else if (model === "波音777-ER") {
		if (["C"].includes(type)) return WAY_SEAT;
		if (["A"].includes(type)) return WINDOW_SEAT;
	} else if (model === "波音787-8") {
		if (["C"].includes(type)) return WAY_SEAT;
		if (["A"].includes(type)) return WINDOW_SEAT;
	} else if (model === "波音737-800") {
		if (["D"].includes(type)) return WAY_SEAT;
		if (["F"].includes(type)) return WINDOW_SEAT;
	}
}, isEqual);

export default SeatIcon;
